import { beEmailMessageApiGetMessageDetailsLazy } from 'Api/beEmailMessageApi'
import { MESSAGE_STR_TYPE_CONTENTSCAMPAIGN } from 'Constants'
import { campaignsBuilderGetEmailCampaignByIdMessage } from 'Api/campaignsBuilderApi'

export async function fetchDetails (idMessage) {
  const {
    Id: id,
    IdList: idList,
    Subject: subject,
    Note: note,
    Size: size,
    Published: published,
    Archived: archived,
    LastUpdated: lastUpdated,
    Tags: tags,
    IsBee: isBee,
    ServiceType: serviceType,
    HasThumbnail: hasThumbnail,
    MessageType: messageType,
    CreationDate: creationDate
  } = await beEmailMessageApiGetMessageDetailsLazy(idMessage)

  let campaign = null

  if (messageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
    campaign = await campaignsBuilderGetEmailCampaignByIdMessage(
      idMessage,
      idList
    )
  }

  return {
    id,
    idList,
    subject,
    note,
    size,
    published,
    archived,
    lastUpdated,
    tags,
    isBee,
    serviceType,
    hasThumbnail,
    messageType,
    creationDate,
    campaign
  }
}
